import { jsx as _jsx } from "react/jsx-runtime";
import useGetResellerBillingHistory from "src/features/resellerBillingHistory/hooks/useGetResellerBillingHistory";
import ResellerBillingsContainer from "src/features/resellerBillingHistory/ResellerBillingsContainer";
const ResellerBillingsContainerWrapper = () => {
    const { isLoading } = useGetResellerBillingHistory();
    return _jsx(ResellerBillingsContainer, { isLoading: isLoading });
};
export default ResellerBillingsContainerWrapper;
